import { Trans } from 'react-i18next'
import type { SelectorKey } from 'i18next'
import styles from './SupportFooter.module.scss'
import Link from 'components/link/Link.tsx'
import { BOLT_EMAIL_CONTACT, BOLT_PHONE_CONTACT } from 'constants/constants.ts'
import { useGetLanguage } from 'hooks/use-get-language'
import { Namespace } from 'translations/types.ts'

const SupportFooter = ({ ns, i18nKey }: { ns: Namespace; i18nKey: SelectorKey }) => {
  // i18n
  const language = useGetLanguage()

  return (
    <footer className={styles.footer}>
      <p>
        <Trans
          ns={ns}
          i18nKey={i18nKey}
          components={{
            tel: <Link href={`tel:${BOLT_PHONE_CONTACT}`} as="a" variant="inline" />,
            mail: <Link href={`mailto:${BOLT_EMAIL_CONTACT[language]}`} as="a" variant="inline" />
          }}
        />
      </p>
    </footer>
  )
}

export default SupportFooter
